import dropTiles from './js/old/dropTiles';
import './scss/old-acf-blocks/droptiles.scss';

dropTiles();
